import { ElementProps } from './types'
import { levelColors } from './constants'

export const getColor = ({ currentRating = 0, isDisabled }: ElementProps, opacity = 0.4) => {
  const color = levelColors[currentRating - 1]
  return color && !isDisabled ? `var(--${color}-${opacity * 100})` : null
}
